import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { TaskService } from '@duck/api-definitions'
import { apis } from '@/modules/apiClients'
import { adminTasksQueryKeys } from './useAdminTasks'

export const useAdminTask = (id: string, options?: { enabled?: boolean }) => {
  const isCreateMode = id === 'new'

  const query = useQuery({
    queryKey: adminTasksQueryKeys.detail(id),
    enabled: (options?.enabled ?? true) && !!id && !isCreateMode,
    queryFn: async () => {
      const response = await apis.taskService.idGet(id)
      return response.data
    },
  })

  const notFound =
    query.isError && (query.error as AxiosError)?.response?.status === 404

  return {
    task: query.data as TaskService.Task | undefined,
    isLoading: query.isPending && !isCreateMode,
    isError: query.isError && !notFound,
    notFound,
    refetch: query.refetch,
  }
}
